import { HandCycleIcon } from './HandCycleIcon';

/**
 * author: Michael Irigoyen
 * id CC8C7CF5-103C-4D0F-A209-05A19DF80F24
 * name hand-cycle
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-cycle.svg
 * tags
 * - Sport 
 */
export const HandBikeIcon = HandCycleIcon;
export default HandBikeIcon